import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";

export const selectOfferReducer = (
  state: LoanState,
  action: PayloadAction<string>,
) => {
  state.offer = state.offers?.find((offer) => offer.id === action.payload);
  state.offers = state.offers?.map((offer) => ({
    ...offer,
    isSelected: offer.id === action.payload,
  }));
};
